import BackgroundImage, { BackgroundImageProps } from './BackgroundImage';

export default BackgroundImage;
export type { BackgroundImageProps };
